import { useSelector } from "react-redux";

export const useUserSelector = () => {
  return useSelector((state) => state.users);
};
export const useSmallBusinessPlansSelector = () => {
  return useSelector((state) => state.users.smallBusinessPlans);
};
export const useEnterprisePlansSelector = () => {
  return useSelector((state) => state.users.getPlans);
};
export const useGetLoadingSelector = () => {
  return useSelector((state) => state.users.loading);
};
